import axios from "axios";
import apiUrlOne from "../../utils.js/Config";

///Contact Us Page 

export const getContactDetails = async () => {
    try {
        const response = await axios.get(`${apiUrlOne}/contact-details`);
        return response.data;
    } catch (error) {
        console.error('Error fetching contact details:', error);
        throw error;
    }
};

export const updateContactDetails = async (id, data) => {
    try {
        const response = await axios.put(`${apiUrlOne}/contact-details/${id}`, data);
        return response.data;
    } catch (error) {
        console.error('Error updating contact details:', error);
        throw error;
    }
};

export const createContactDetails = async (data) => {
    try {
        const response = await axios.post(`${apiUrlOne}/contact-details`, data);
        return response.data;
    } catch (error) {
        console.error('Error creating contact details:', error);
        throw error;
    }
};


///Enquiries 

export const getEnquiries = async (params = {}) => {
    try {
        const response = await axios.get(`${apiUrlOne}/enquiries`, { params });
        return response.data;
    } catch (error) {
        console.error('Error fetching enquiries:', error);
        throw error;
    }
};

export const getEnquiryById = async (id) => {
    try {
        const response = await axios.get(`${apiUrlOne}/enquiries/${id}`);
        return response.data;
    } catch (error) {
        console.error('Error fetching enquiry by id:', error);
        throw error;
    }
};

export const updateEnquiry = async (id, data) => {
    try {
        const response = await axios.put(`${apiUrlOne}/enquiries/${id}`, data);
        return response.data;
    } catch (error) {
        console.error('Error updating enquiry:', error);
        throw error;
    }
};
